import {Component} from 'substance'

class PluginFormComponent extends Component {

    getInitialState() {
        return {
            plugin: this.props.plugin,
            enabled: !this.props.plugin ? false : (this.props.plugin.enabled ? true : false),
            mandatory: !this.props.plugin ? false : (this.props.plugin.mandatory ? true : false),
            id: !this.props.plugin ? '' : this.props.plugin.id || '',
            name: !this.props.plugin ? '' : this.props.plugin.name || '',
            style: !this.props.plugin ? '' : this.props.plugin.style || '',
            url: !this.props.plugin ? '' : this.props.plugin.url || '',
            tab: !this.props.plugin ? '' : this.props.plugin.tab || ''
        }
    }

    didMount() {
        this.props.setGetFormDataEndPoint(() => {
            return this._getFormData()
        })
    }

    /**
     * @returns {{id: *, name: *, style: *, url: *, mandatory: (boolean|*), enabled}}
     * @private
     */
    _getFormData() {
        const formValues = {
            id: this.state.id,
            name: this.state.name,
            style: this.state.style,
            url: this.state.url,
            tab: this.state.tab,
            mandatory: this.state.mandatory,
            enabled: this.state.enabled
        }

        return Object.keys(formValues)
            .filter((key) => formValues[key] !== '')
            .reduce((obj, key) => {
                obj[key] = formValues[key]
                return obj
            }, {})
    }

    render($$) {
        return $$('div').attr({id: 'configurationtesttool_form'}).append([
            this._renderInput($$, 'id', 'Id'),
            this._renderInput($$, 'name', 'Name'),
            this._renderInput($$, 'url', 'Plugin src url'),
            this._renderInput($$, 'style', 'Plugin css url'),
            this._renderInput($$, 'tab', 'Overridden Tab'),
            this._renderToggle($$, 'enabled', 'Enabled'),
            this._renderToggle($$, 'mandatory', 'Mandatory'),
            $$('div')
                .addClass('menu')
                .append(
                    $$('i')
                        .ref('clipboardInitiator')
                        .addClass('fa fa-clipboard')
                        .attr({title: 'Copy this plugins config to clipboard'})
                        .on('click', () => {
                            const cfg = this.props.getCurrentPluginConfig()
                            if (cfg) {
                                this.refs['clipboardHelper'].val(JSON.stringify(cfg, null, '    '))
                                this.refs['clipboardHelper'].el.el.select()
                                document.execCommand('copy')
                                this.refs['clipboardInitiator'].el.el.classList.add('clicked')
                                setTimeout(() => {
                                    this.refs['clipboardInitiator'].el.el.classList.remove('clicked')
                                }, 190)
                            }
                        })
                ),
            $$('textarea')
                .ref('clipboardHelper')
                .css({
                    position: 'absolute',
                    left: '-9999999px'
                })
        ])
    }

    /**
     * @param $$
     * @param id
     * @param label
     * @returns {VirtualElement}
     * @private
     */
    _renderInput($$, id, label) {
        const inputId = `devtool-configtestool-${id}`

        return $$('div').addClass('form-group flexible-label').append(
            $$('input')
                .ref(id)
                .on('change', () => {
                    const state = {}
                    state[id] = this.refs[id].val()
                    this.extendState(state)
                })
                .addClass('form-control')
                .attr({
                    required: 'required',
                    type: 'text',
                    id: inputId,
                    placeholder: label
                })
                .val(this.state[id]),
            $$('label')
                .attr('for', inputId)
                .append(label)
        )
    }

    /**
     * @param $$
     * @param id
     * @param label
     * @returns {VirtualElement}
     * @private
     */
    _renderToggle($$, id, label) {
        const UIToggle = this.context.configurator.getComponent('UIToggle')
        const value = this.state.plugin ? this.state.plugin[id] : ''

        return $$(UIToggle, {
            id: id,
            label: label,
            checked: value,
            onToggle: checked => {
                const state = {}
                state[id] = checked
                this.extendState(state)
            }
        }).ref(id)
    }
}

export default PluginFormComponent
